import { useAPI } from "kw/api/useAPI";
import { useState } from "react";
import { TDashboardStats } from "kw/admin/DashboardPage";

export const useStats = () => {
  const [stats, setStats] = useState<TDashboardStats>();
  const { query, loading } = useAPI();
  const fetchStats = () => {
    query(statsQuery, (response: { admin: { dataAnalytics: TDashboardStats } }) => {
      setStats(response.admin.dataAnalytics);
    });
  };

  return {
    stats,
    loading,
    fetchStats,
  };
};

const statsQuery = {
  admin: {
    dataAnalytics: {
      totalQuotes: {
        title: true,
        summaryValue: true,
        summaryValueType: true,
        statistics: {
          label: true,
          value: true,
          type: true,
        },
      },
      quotesThisMonth: {
        title: true,
        statistics: {
          label: true,
          value: true,
          type: true,
        },
      },
      policiesByStatus: {
        title: true,
        statistics: {
          label: true,
          value: true,
          type: true,
        },
      },
      policiesRenewed: {
        title: true,
        statistics: {
          label: true,
          value: true,
          type: true,
        },
      },
      totalActivePolicies: {
        title: true,
        statistics: {
          label: true,
          value: true,
          type: true,
        },
      },
      totalCustomers: {
        title: true,
        summaryValue: true,
        summaryValueType: true,
        statistics: {
          label: true,
          value: true,
          type: true,
        },
      },
      totalGwp: {
        title: true,
        statistics: {
          label: true,
          value: true,
          type: true,
        },
      },
      conversionRate: {
        title: true,
        statistics: {
          label: true,
          value: true,
          type: true,
        },
      },
      totalClaims: {
        title: true,
        statistics: {
          label: true,
          value: true,
          type: true,
        },
      },
    },
  },
};
